import { useNavigate } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export const PROMAX_LOGO_ALT = "Rally Love PROMAX – documenti e notifiche ufficiali per rally";

export function PromaxLogo({ className = "", sizes = "(max-width: 640px) 90vw, 480px" }) {
  return (
    <picture>
      <source srcSet="/rally-love-promax-logo.webp" type="image/webp" />
      <img src="/rally-love-promax-logo.png" alt={PROMAX_LOGO_ALT} width="1600" height="640" sizes={sizes} loading="lazy" decoding="async" className={`block mx-auto w-full h-auto object-contain ${className}`} data-testid="promax-logo" />
    </picture>
  );
}

export default function PromaxCard() {
  const nav = useNavigate();
  const go = (e, to) => { e.preventDefault(); e.stopPropagation(); nav(to); };
  return (
    <div role="link" tabIndex={0} onClick={() => nav("/promax")} onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); nav("/promax"); } }} aria-label="Scopri Rally Love PROMAX" data-testid="pro-svc-promax"
      className="group rl-card p-7 flex flex-col gap-4 border-[#FF1E27]/30 shadow-[0_0_40px_rgba(255,30,39,0.08)] hover:border-[#FF1E27]/70 hover:shadow-[0_0_60px_rgba(255,30,39,0.18)] hover:-translate-y-0.5 transition duration-300 cursor-pointer focus-visible:outline focus-visible:outline-2 focus-visible:outline-[#FF9F0A] min-w-0">
      <div className="flex items-center justify-between gap-2"><span className="pill-badge !text-[9px]">PER ORGANIZZATORI</span><span className="pill-badge pill-amber !text-[9px]">NUOVO</span></div>
      <div className="bg-black rounded-lg px-3 py-4 border border-white/5 group-hover:border-[#FF1E27]/30 transition-colors"><PromaxLogo className="max-w-[360px]" sizes="(max-width: 640px) 80vw, 360px" /></div>
      <h3 className="font-display font-black text-xl">Rally Love PROMAX</h3>
      <p className="text-sm text-slate-400 flex-1 leading-relaxed">Documenti ufficiali, comunicazioni e notifiche istantanee per concorrenti e partecipanti al rally.</p>
      <div className="flex flex-wrap gap-2 mt-1">
        <button type="button" className="btn-crimson !py-2.5 !px-4 text-xs min-h-[44px] flex items-center gap-1" onClick={(e) => go(e, "/promax")} data-testid="pro-svc-promax-btn">SCOPRI PROMAX<ChevronRight className="w-4 h-4" /></button>
        <button type="button" className="btn-outline-rl !py-2.5 !px-4 text-xs min-h-[44px]" onClick={(e) => go(e, "/promax/access")} data-testid="pro-svc-promax-access-btn">ACCEDI AL SERVIZIO</button>
      </div>
    </div>
  );
}
